/**
 * Redesigned Revenue product, served only to the accounts inside the gated
 * rollout (see utils/revenue/has-revenue-access). App.vue swaps it in over the
 * legacy entry, which keeps the array length and ordering intact — the rail
 * indexes into it by position.
 */
export const revenueBetaProduct =
  {
    title: 'Ingresos',
    icon: 'Revenue',
    parent: 'PaymentListCreate',
    link: 'RevenueSummary',
    options: [
      {
        title: 'Resumen',
        link: 'RevenueSummary'
      },
      {
        title: 'Pagos',
        link: 'PaymentListCreate'
      },
      {
        title: 'Conciliación',
        link: 'TransactionList'
      },
      {
        title: 'Cuentas por cobrar'
      },
      {
        // exact: Recordatorios y Reglas de envío cuelgan de /receivables en la
        // URL pero son hermanos en el menú, así que sin esto Análisis quedaría
        // activo al estar parado en cualquiera de las dos
        title: 'Análisis',
        link: 'Receivables',
        exact: true
      },
      {
        title: 'Acuerdos',
        link: 'AgreementList'
      },
      {
        title: 'Contactabilidad'
      },
      {
        title: 'Recordatorios',
        link: 'ReminderList'
      },
      {
        title: 'Reglas de envío',
        link: 'RuleViewSet'
      }
    ]
  }

export default [
  {
    title: 'Dashboard',
    icon: 'AccountDashboard',
    link: 'AccountDashboard'
  },
  {
    title: 'Suscripciones',
    icon: 'Subscriptions',
    link: 'SubscriptionList',
    options: [
      {
        title: 'Facturas recurrentes',
        link: 'SubscriptionList'
      },
      {
        title: 'Productos',
        link: 'ProductListCreate'
      },
      {
        title: 'Complementos',
        link: 'AddonListCreate'
      },
      {
        title: 'Cupones de descuento',
        link: 'CouponListCreate'
      },
      {
        title: 'Gestionar'
      },
      {
        title: 'Registros de uso',
        link: 'UsageListCreate'
      },
      {
        title: 'Documentos de soporte',
        link: 'SupportingDocumentListCreate'
      }
    ]
  },
  {
    title: 'Facturación',
    icon: 'Invoicing',
    link: 'InvoiceList',
    options: [
      {
        title: 'Facturas',
        link: 'InvoiceList'
      },
      {
        title: 'Notas de crédito',
        link: 'CreditNoteList'
      },
      {
        title: 'Órdenes',
        link: 'OrderList'
      }
    ]
  },
  {
    title: 'Ingresos',
    icon: 'Revenue',
    // `parent` is what routes point at through meta.parent, and it never
    // changes; `link` is only where the rail icon lands, so the gated rollout
    // can swap it without touching a single route
    parent: 'PaymentListCreate',
    link: 'PaymentListCreate',
    options: [
      {
        title: 'Pagos',
        link: 'PaymentListCreate'
      },
      {
        title: 'Transferencias',
        link: 'TransactionList'
      },
      {
        title: 'Cuentas por cobrar',
        link: 'Receivables'
      }
    ]
  },
  {
    title: 'Contactos',
    icon: 'Contacts',
    link: 'CustomerListCreate',
    options: [
      {
        title: 'Clientes',
        link: 'CustomerListCreate'
      },
      {
        title: 'Personas',
        link: 'ContactListCreate'
      }
    ]
  },
  {
    title: 'Componentes',
    icon: 'Components',
    link: 'Components'
  },
  {
    title: 'Reportes',
    icon: 'Reports',
    link: 'DashboardUpdate',
    options: [
      {
        title: 'Mis dashboards',
        isFreeComponent: true,
        component: 'DashboardDropDown'
      },
      {
        title: 'Colección de métricas',
        isFreeComponent: true,
        component: 'MetricsDropDown'
      }
      // {
      //   title: 'Explorador de dashboards',
      //   link: 'DefaultDashboardList'
      // },
      // {
      //   title: 'Favoritos',
      //   link: 'Favorites'
      // },
    ]
  },
  {
    title: 'Integraciones',
    icon: 'Integrations',
    link: 'Integrations',
    options: [
      {
        title: 'Documentos recibidos',
        description: '',
        link: 'PurchaseList'
      },
      {
        title: 'Facturas de compra',
        description: '',
        link: 'RetentionList',
        options: [
          {
            title: 'Lotes',
            description: '',
            link: 'RetentionBulkListCreate'
          }
        ]
      },
      {
        title: 'Proveedores',
        description: '',
        link: 'SupplierListCreate'
      }
    ]
  },
  {
    title: 'Configuración',
    description: '',
    link: 'AccountBasic',
    options: [
      {
        title: 'Cuenta',
        description: '',
        link: 'AccountBasic'
      },
      {
        title: 'Branding',
        description: '',
        link: 'AccountSettingsBranding'
      },
      {
        title: 'Facturación',
        description: '',
        link: 'AccountSettingsInvoicing'
      },
      {
        title: 'Pagos',
        description: '',
        link: 'AccountSettingsPayments'
      },
      {
        // hidden for the accounts on the new experience, where bank accounts
        // are managed from Conciliación instead
        title: 'Banco',
        description: '',
        link: 'AccountSettingsBank',
        hideOnRevenueBeta: true
      },
      {
        title: 'Correos electrónicos',
        description: '',
        link: 'AccountSettingsEmail'
      },
      {
        title: 'Notificaciones',
        description: '',
        link: 'AccountSettingsNotifications'
      },
      {
        title: 'Webhooks',
        description: '',
        link: 'AccountSettingsWebhooksListCreate'
      },
      {
        title: 'Equipo',
        description: '',
        link: 'AccountMembers'
      },
      {
        title: 'Importar',
        description: '',
        link: 'AccountImports'
      },
      {
        title: 'Exportar',
        description: '',
        link: 'AccountExports'
      },
      {
        title: 'Facturación de Piriod',
        description: '',
        link: 'AccountBilling'
      }
    ]
  },
  {
    title: 'Agentes',
    icon: 'Agents',
    link: 'AgentList',
    options: [
      {
        title: 'Todos los agentes',
        link: 'AgentList'
      },
      {
        title: 'Feed',
        link: 'AgentInbox'
      },
      {
        title: 'Crear agente',
        link: 'AgentCreate'
      },
      {
        title: 'Recientes',
        isFreeComponent: true,
        component: 'AgentsDropDown'
      }
    ]
  }
]